import React, { useState } from "react";
import { ChevronDown, ChevronUp, CheckCircle2, BookOpen, Lightbulb } from "lucide-react";
import { ExerciseBox } from "./ExerciseBox";

export const ModuleCard = ({ module, index, onSaved, basePath = "/academia" }) => {
  const [open, setOpen] = useState(false);
  const done = module.exercises.every((e) => e.saved_answer);

  return (
    <div data-testid={`module-${module.module_id}`} className="rounded-2xl border border-white/10 bg-emerald-950/60 overflow-hidden">
      <button
        data-testid={`module-toggle-${module.module_id}`}
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-3 px-5 py-4 text-left hover:bg-white/5 transition-colors"
      >
        <div className={`w-9 h-9 rounded-full flex items-center justify-center text-sm font-black shrink-0 ${done ? "bg-emerald-500 text-white" : "bg-yellow-400/15 text-yellow-300 border border-yellow-400/40"}`}>
          {done ? <CheckCircle2 size={18} /> : index + 1}
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-bold text-sm sm:text-base text-zinc-100">{module.title}</h3>
          <p className="text-[11px] text-zinc-500">{module.exercises.length} ejercicio{module.exercises.length > 1 ? "s" : ""} {done ? "· completado ✓" : ""}</p>
        </div>
        {open ? <ChevronUp size={18} className="text-zinc-400 shrink-0" /> : <ChevronDown size={18} className="text-zinc-400 shrink-0" />}
      </button>
      {open && (
        <div className="px-5 pb-5">
          <p className="text-sm text-zinc-300 leading-relaxed">{module.intro}</p>
          {module.points?.length > 0 && (
            <ul className="mt-3 space-y-1.5">
              {module.points.map((p, i) => (
                <li key={p} className="flex gap-2 text-sm text-zinc-300">
                  <BookOpen size={14} className="text-emerald-400 mt-0.5 shrink-0" /> <span>{p}</span>
                </li>
              ))}
            </ul>
          )}
          {module.example && (
            <div className="mt-3 rounded-xl bg-emerald-500/10 border border-emerald-500/30 p-3 flex gap-2">
              <Lightbulb size={15} className="text-yellow-300 mt-0.5 shrink-0" />
              <p className="text-xs text-emerald-100/90"><span className="font-bold">Ejemplo: </span>{module.example}</p>
            </div>
          )}
          {module.exercises.map((e) => (
            <ExerciseBox key={e.exercise_id} exercise={e} onSaved={onSaved} basePath={basePath} />
          ))}
        </div>
      )}
    </div>
  );
};
